// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4r-1";
export var standaloneTable = "_4r-0";